/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import {
  setDoc,
  doc,
  collection,
  writeBatch,
} from "firebase/firestore";
import { db } from "../../../firebase";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import usePagination from "../../helper/paginate/Pagination";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "./DataTableDemo.css";
import { Link } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert"; // Import
import { fetchDate } from "../../../utils/globleFunc";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import useIsDark from "../../../utils/isDark";


const DataTableTemplatingDemo = ({ filter, orders, pageSize }) => {
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const [expandedRows, setExpandedRows] = useState(null);
  const [bug, setBug] = useState(true);
  const [productdata, setProductData] = useState([]);
  const [bluck, setBluck] = useState("");
  let [page, setPage] = useState(1);
  const PER_PAGE = pageSize;
  const count = Math.ceil(orders.length / PER_PAGE);
  const _DATA = usePagination(orders, PER_PAGE);
  const { t, i18n } = useTranslation();
  const isDark = useIsDark(); 

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };
  const [currentDate, setCurrentDate] = useState("");
  useEffect(() => {
    const fetchAndSetCurrentDate = async () => {
      const res = await fetchDate();
      setCurrentDate(res);
    };

    fetchAndSetCurrentDate();

    const interval = setInterval(() => fetchAndSetCurrentDate(), 1000); // Fetch date every minute
    return () => clearInterval(interval); // Cleanup function
  }, []);

  const statusBodyTemplate = (rowData) => {
    let color = "#fff";
    if (rowData.deleveryStatus === "1") {
      color = "#fff";
    }
    if (rowData.deleveryStatus === "2") {
      color = "#e1a626";
    }
    if (rowData.deleveryStatus === "3") {
      color = "#25c7bf";
    }
    if (rowData.deleveryStatus === "4") {
      color = "#8c5fa5";
    }
    if (rowData.deleveryStatus === "5") {
      color = "#49a688";
    }
    if (rowData.deleveryStatus === "6") {
      color = "#e87778";
    }
    return (
      <Form.Select
        aria-label={t("ship.order_status")}
        className={rowData.deleveryStatus === "1" ? `text-dark` : `text-white`}
        value={rowData.deleveryStatus}
        onChange={(e) => {
          changeStatus(rowData, e.target.value);
        }}
        style={{
          backgroundColor: `${color}`,
          zIndex: "9000",
        }}
      >
        {rowData.deleveryStatus !== "5" && (
          <>
            <option value="1">{t("orders.new")}</option>
            <option value="2">{t("ui.preparing")}</option>
            <option value="3">{t("ui.ready")}</option>
            <option value="4">{t("ui.delivering")}</option>
          </>
        )}
        <option value="5">{t("ui.completed")}</option>
        {rowData.deleveryStatus !== "5" && <option value="6">{t("orderDetails.statusOptions.6")}</option>}
      </Form.Select>
    );
  };

  const dateBodyTemplate = (rowData) => {
    const date = new Date(rowData.timeStamp.seconds * 1000);
    return <span>{date.toLocaleString().toString()}</span>;
  };

  const orderNumber = (rowData) => {
    return (
      <Link
        style={{ textDecoration: "none" }}
        to={`/orders/details`}
        state={{
          from: {
            ...rowData,
          },
          product: productdata.filter(
            (product) => product.id === rowData.productId
          )[0],
          products: productdata,
        }}
      >
        {rowData.index}
      </Link>
    );
  };

  const orderTotal = (rowData) => {
    return (
      <>
        {rowData.total} {store.currencySymbol}
      </>
    );
  };

  const changeStatus = async (data, status) => {
    await setDoc(doc(db, "orders", data.id), {
      ...data,
      deleveryStatus: status,
    });
  };

  const planTemplate = (rowData) => {
    return <div>{rowData.planName}</div>;
  };
  const paymentMethodTemplate = (rowData) => {
    return (
      <p>
        {rowData.paymentMethod === 1 && t("SubscriptionSettings.payment_methods.1")}
        {rowData.paymentMethod === 2 && t("SubscriptionSettings.payment_methods.2")}
        {rowData.paymentMethod === 3 && t("SubscriptionSettings.payment_methods.3")}
      </p>
    );
  };
  const paymentStatusTemplate = (rowData) => {
    return (
      <div>
        {rowData.isValid === 1 && (
          <span className="py-2 px-3 rounded-full font-semibold text-xs text-blue-600 bg-blue-50">
            {t("SubscriptionSettings.status.new")}
          </span>
        )}
        {rowData.isValid === 2 && (
          <span
            className="py-2 px-3 rounded-full font-semibold text-xs "
            style={{ backgroundColor: "#ffb40036", color: "#ff9d02" }}
          >
            {t("SubscriptionSettings.status.pending")}
          </span>
        )}
        {rowData.isValid === 3 && (
          <span className="ppy-2 px-3 rounded-full font-semibold text-xs text-green-600 bg-green-50">
            {t("SubscriptionSettings.status.paid")}
          </span>
        )}
        {rowData.isValid === 4 && (
          <span className="py-2 px-3 rounded-full font-semibold text-xs text-red-600 bg-red-50">
            {t("SubscriptionSettings.status.rejected")}
          </span>
        )}
        {rowData.isValid === 5 && (
          <span className="py-2 px-3 rounded-full font-semibold text-xs text-blue-600 bg-blue-50">
            {t("SubscriptionSettings.status.auto")}
          </span>
        )}
      </div>
    );
  };
  const darkModeStyles = `
  /* Styles pour le mode sombre du DataTable */
  .dark .p-datatable .p-datatable-thead > tr > th {
    background-color: #1e1e1e !important;
    color: #d1d5db !important;
    border-color: #3c3a3d !important;
    border-top: 1px solid #3c3a3d !important;
    border-bottom: 1px solid #3c3a3d !important;
    border-left: 1px solid #1e1e1e !important;
    border-right: 1px solid #1e1e1e !important;
  }
  
  .dark .p-datatable .p-datatable-tbody > tr {
    background-color: #181919 !important;
    color: #d1d5db !important;
  }
  
  .dark .p-datatable .p-datatable-tbody > tr:nth-child(even) {
    background-color: #1e1e1e !important;
  }
  
  .dark .p-datatable .p-datatable-tbody > tr:nth-child(odd) {
    background-color: #181919 !important;
  }
  
  .dark .p-datatable .p-datatable-tbody > tr > td {
    border-color: #3c3a3d !important;
    color: #d1d5db !important;
  }

  
  /* Pour les bordures du tableau */
  .dark .p-datatable {
    border-color: #3c3a3d !important;
  }
  
  /* Pour les éléments expandables */
  .dark .p-datatable .p-row-expansion {
    background-color: #141414 !important;
    color: #d1d5db !important;
  }
`;

  return (
    <div className="datatable-templating-demo dark:!bg-[#181919]">
      <div className="">
        <style>{darkModeStyles}</style>
        <DataTable
          value={
            !!filter
              ? orders.filter(
                (order) =>
                  order.index
                    .toString()
                    .toLowerCase()
                    .includes(filter.toLowerCase()) ||
                  order.name.toLowerCase().includes(filter.toLowerCase()) ||
                  order.phone.toLowerCase().includes(filter.toLowerCase())
              )
              : _DATA.currentData()
          }
          responsiveLayout="scroll"
          className="mx-2 rounded"
          disabledSelection={true}
          emptyMessage={t("SubscriptionSettings.table.empty")}
        >
          <Column
            body={orderNumber}
            field="index"
            className="text-end"
            header={t("SubscriptionSettings.table.invoice_number")}
            sortable
          ></Column>
          <Column
            body={dateBodyTemplate}
            className="text-end"
            header={t("SubscriptionSettings.table.purchase_date")}
            sortable
          ></Column>
          <Column
            body={paymentMethodTemplate}
            className="text-end"
            header={t("SubscriptionSettings.table.payment_method")}
            sortable
          ></Column>
          <Column
            body={planTemplate}
            className="text-end"
            header={t("SubscriptionSettings.table.plan_type")}
            sortable
          ></Column>
          <Column
            style={{ color: "#6e4881" }}
            body={orderTotal}
            className="text-end"
            header={t("SubscriptionSettings.table.total_amount")}
            sortable
          ></Column>
          <Column
            header={t("SubscriptionSettings.table.payment_status")}
            className="text-end"
            body={paymentStatusTemplate}
          ></Column>
        </DataTable>
      </div>
      <div className="d-flex justify-content-center py-3">
        <Stack spacing={2} dir="ltr">
          <Pagination
            count={count}
            size="large"
            page={page}
            variant="outlined"
            shape="rounded"
            onChange={handleChange}
            color="secondary"
                 sx={{
                backgroundColor: isDark ? '#181919' : '#ffffff',
                borderRadius: 2,
                p: 2,
                '& .MuiPaginationItem-root': {
                  color: isDark ? '#e1cfff' : '#000000',
                  borderColor: isDark ? '#a065c0' : '#ccc',
                },
                '& .MuiPaginationItem-root.Mui-selected': {
                  backgroundColor: isDark ? '#9b59bf' : '#9b59bf',
                  color: '#fff',
                },
                '& .MuiPaginationItem-root:hover': {
                  backgroundColor: isDark ? '#7c3aad' : '#f0f0f0',
                }
              }}
          />
        </Stack>
      </div>
    </div>
  );
};

export default DataTableTemplatingDemo;
